<template>
  <div class="bs-docs-section pt-1 mx-3" id="about-us">
    <div class="jumbotron-alt">
      <div class="row">
        <div class="col-lg-12">
          <div class="page-header text-center">
            <h4 id="containers">About Us</h4>
            <hr class="w-80" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 mb-5" data-aos="fade-up" data-aos-delay>
          <figure class="circle-bg">
            <img
              :src="getImageURL('aboutUs.jpg')"
              alt="Finult Co About Us"
              class="d-block w-100"
            />
          </figure>
        </div>
        <div class="col-lg-7 ml-auto" data-aos="fade-up" data-aos-delay="100">
          <p>
            Finult is Financial Accounting Outsourcing and Consulting company
            with multidisciplinary team of accounting, tax and audit
            professionals based out of Bangalore, India. Finult was established
            by a team of industry professionals having illustrious careers. The
            idea behind constituting Finult was to provide comprehensive
            services that can help businesses acquire an edge over others while
            keeping their focus on developing their core departments.
          </p>
          <p>
            We offer a range of services to meet the complex and evolving
            accounting, tax and compliance challenges. Our team comprises of
            Chartered Accountants, Company Secretaries, Legal Professionals,
            Cost accountants and other Finance professionals will help you keep
            your priorities straight. We at Finult have a credible track record
            of partnering with Clients across industry sectors.
          </p>
          <p>
            Finult aims to deliver business outcomes through analytics, deep
            industry insights and innovation. Leveraging our professional
            resources and knowledge base, we strive to achieve high levels of
            service quality and consistency.
          </p>

          <p>
            We at Finult, are committed to ensuring that our services are
            provided objectively, maintaining the highest ethical & professional
            standards with paramount emphasis on the interest of the clients.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {};
  },
  methods: {
    getImageURL(imageURL) {
      return imageURL ? require(`../assets/images/${imageURL}`) : "";
    }
  }
};
</script>

<style>
.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 1rem;
}
.jumbotron-alt {
  padding: 2rem 1rem;
  margin-bottom: 1rem;
  background-color: #faf7ec;
  border-radius: 0.3rem;
}
</style>